define.alias("shared/components/shared/ui/social-profile-switcher", "calendar/components/shared/ui/social-profile-switcher");